<template>
  <div class="pt-4">
    <div class="flex pb-4">
      <div class="flex-1">
        <div class="pr-1">
          <v-menu ref="menuStart" v-model="datePickerStart.menu" :close-on-content-click="false"
            :return-value.sync="datePickerStart.date" lazy transition="scale-transition" offset-y full-width
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
                <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{
                  languages.date.from }}</label>
                <div>
                  <div>
                    <input data-vs-input="start-date" id="documents-search-periodsincefilter" v-on="on"
                      v-model="setInputStartDate" type="text" class="outline-none py-2 w-full" />
                  </div>
                </div>
              </div>
            </template>
            <v-date-picker v-model="datePickerStart.date" @input="setInputStartPicker" type="month"
              :locale="vuetifyLocale" no-title scrollable>
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <div class="flex-1">
        <div class="pl-1">
          <v-menu ref="menuEnd" v-model="datePickerEnd.menu" :close-on-content-click="false"
            :return-value.sync="datePickerEnd.date" lazy transition="scale-transition" offset-y full-width
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
                <label class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{ languages.date.to
                  }}</label>
                <div>
                  <div>
                    <input data-vs-input="end-date" id="documents-search-periodtofilter" v-on="on"
                      v-model="setInputEndDate" type="text" class="outline-none py-2 w-full" />
                  </div>
                </div>
              </div>
            </template>
            <v-date-picker v-model="datePickerEnd.date" @input="setInputEndPicker" type="month" :locale="vuetifyLocale"
              :min="minDateTo" no-title scrollable>
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <div v-show="isResetDatesVisible" class="px-2 inline-flex items-center">
        <button data-vs-button="clear-inputs" @click="clearInputs"
          class="text-zt-primary-200 text-zt-xl focus:outline-none">
          <zt-icon name="times-solid" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import addGTMClass from '@/utils/addGTMClass'
import { mapGetters } from 'vuex';

const formatInput = (date, format) => {
  return moment(date).format(format)
}

export default {
  name: 'DateFilter',
  data() {
    return {
      datePickerStart: {
        date: '',
        menu: false
      },
      datePickerEnd: {
        date: '',
        menu: false
      },
      languages: {
        date: {
          from: this.$t("message.LicensesManager.search.fromPeriod"),
          to: this.$t("message.LicensesManager.search.toPeriod")
        }
      },
      gtmIds: [
        'documents-search-periodsincefilter',
        'documents-search-periodtofilter'
      ]
    }
  },
  mounted() {
    addGTMClass(this.gtmIds)
  },
  computed: {
    ...mapGetters({
      locale: 'getLocale',
    }),
    minDateTo() {
      return this.datePickerStart.date
    },
    setInputStartDate() {
      if (!this.datePickerStart.date) {
        return null
      }
      return formatInput(this.datePickerStart.date, 'MM/YYYY')
    },
    setInputEndDate() {
      if (!this.datePickerEnd.date) {
        return null
      }
      return formatInput(this.datePickerEnd.date, 'MM/YYYY')
    },
    isResetDatesVisible() {
      return !!this.datePickerStart.date || !!this.datePickerEnd.date
    },
    vuetifyLocale() {
      return this.locale === 'br' ? 'pt' : 'es'
    }
  },
  methods: {
    setInputStartPicker() {
      this.$refs.menuStart.save(this.datePickerStart.date)
      this.$refs.menuEnd.save(this.datePickerEnd.date)
      this.$emit('signed-date', {
        signed: {
          start: this.setInputStartDate,
          end: this.setInputEndDate
        }
      })
      this.datePickerStart.menu = false
    },
    setInputEndPicker() {
      this.datePickerEnd.menu = false
      this.$refs.menuEnd.save(this.datePickerEnd.date)
      this.$emit('signed-date', {
        signed: {
          start: this.setInputStartDate,
          end: this.setInputEndDate
        }
      })
    },
    clearInputs() {
      this.datePickerStart.date = ''
      this.datePickerEnd.date = ''
      this.$emit('signed-date', {
        signed: {
          start: '',
          end: ''
        }
      })
    }
  }
}
</script>
